module.exports = __webpack_public_path__ + "img/img7.f7c9be9f.svg";